export default __webpack_public_path__ + "static/media/site.3f27959f.svg";